import type { InboxAccount, InboxEmail } from '../features/inbox/inboxShared';

const emailsByAccount = new Map<string, InboxEmail[]>();
let cachedAccounts: InboxAccount[] | null = null;

function accountCacheKey(accountId: string | number): string {
  return String(accountId);
}

export function getCachedInboxAccounts(): InboxAccount[] | null {
  return cachedAccounts;
}

export function setCachedInboxAccounts(accounts: InboxAccount[]): void {
  cachedAccounts = accounts;
}

export function getCachedInboxEmails(accountId: string | number): InboxEmail[] | null {
  return emailsByAccount.get(accountCacheKey(accountId)) ?? null;
}

export function setCachedInboxEmails(accountId: string | number, emails: InboxEmail[]): void {
  emailsByAccount.set(accountCacheKey(accountId), emails);
}
